export enum InstructorType {
  External = 0,
  Internal = 1,
}

export enum CourseInstructorType {
  Internal = 1,
  External = 2,
}

export enum CoursesTab {
  Instructors = 'instructors',
  Rooms = 'rooms',
  Courses = 'courses',
}

export enum WorkShiftsTab {
  Shifts = 'shifts',
  Form = 'form',
}

export enum RoomType {
  External = 0,
  Internal = 1,
}

export enum CourseType {
  External = 0,
  Internal = 1,
}

export enum CourseVisibility {
  Public = 1,
  Private = 2,
  Group = 3,
  Club = 4,
}
